import { Component, input, output } from '@angular/core';
import { ClDialog } from '@corelabs/angular/ui';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css'],
    imports: [ClDialog, ButtonComponent],
})
export class ConfirmDialogComponent {
    readonly header = input.required<string>();
    readonly message = input.required<string>();
    readonly confirmLabel = input.required<string>();
    readonly cancelLabel = input.required<string>();

    readonly confirm = output<void>();
    readonly cancelled = output<void>();

    protected readonly messageId = crypto.randomUUID();
}
